import { gql } from '@apollo/client'

export const field = 'users'

export default gql`
  query getUsers {
    users {
      id
      username
    }
  }
`
